module.exports = __webpack_public_path__ + "img/project-hover.9cdc9e80.png";